import { render, staticRenderFns } from "./ProjectIntroduction.vue?vue&type=template&id=6e0e945d&scoped=true"
import script from "./ProjectIntroduction.vue?vue&type=script&lang=js"
export * from "./ProjectIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0e945d",
  null
  
)

export default component.exports